import { useState } from 'react';
import { Modal } from '../../Modal';
import { Button, Input, Typography } from '../ui';
import { devToolsUnlocked } from '../../../lib/dev-tools';
import { readBlogDraftPreviewCard } from '../../../lib/blog-draft-preview';
import { BlogDraftPreviewCard } from '../chat-surface/MessageRow/BlogDraftPreviewCard';

export function DevBlogDraftPreviewPanel(props: { open: boolean; onClose: () => void }) {
  if (!devToolsUnlocked()) return null;
  return <BlogDraftPreviewPanel {...props} />;
}

function BlogDraftPreviewPanel({ open, onClose }: { open: boolean; onClose: () => void }) {
  const [metaSiteId, setMetaSiteId] = useState('');
  const [draftPostId, setDraftPostId] = useState('');
  const [title, setTitle] = useState('');
  const card = readBlogDraftPreviewCard({ blogDraftPreviewCard: { metaSiteId, draftPostId, title } });
  return (
    <Modal open={open} onClose={onClose} width={560} title="Blog draft preview card" footer={<Button onClick={onClose}>Done</Button>}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
        <Typography variant="p3" color="secondary">
          The card a reply carries when the agent writes a blog draft post, for one of your own sites&apos; drafts. It shows only while
          symphonyBlogDraftPreview is on (Feature toggles).
        </Typography>
        <Input label="Site (metaSiteId)" value={metaSiteId} onChange={(e) => setMetaSiteId(e.target.value.trim())} />
        <Input label="Draft post id" value={draftPostId} onChange={(e) => setDraftPostId(e.target.value.trim())} />
        <Input label="Title" value={title} onChange={(e) => setTitle(e.target.value)} />
        {card ? (
          <BlogDraftPreviewCard card={card} />
        ) : (
          <Typography variant="p3" color="secondary">
            Both ids are GUIDs.
          </Typography>
        )}
      </div>
    </Modal>
  );
}
